import React from 'react';
import PropTypes from 'prop-types';
import ReduxModal from 'components/reduxModal';
import { Trans } from 'components';

const MODAL_ID = 'invoice-address-edit-success';

const AddInvoiceAddressInfo = ({ close }) => (
  <ReduxModal
    id={MODAL_ID}
  >
    {(Modal, { extra }) => (
      <div>
        <Modal.Heading title={<div><Trans>Adres do faktury firmy</Trans> <br/><strong>{extra.address.name}</strong> {<span><br/><Trans>został edytowany</Trans></span>}</div>} />
        <Modal.Footer>
          <button type="button" onClick={close} className="full-btn has-margin-left"><Trans>OK, rozumiem</Trans></button>
        </Modal.Footer>
      </div>
    )}
  </ReduxModal>
);

AddInvoiceAddressInfo.propTypes = {
  close: PropTypes.func.isRequired
}

export default AddInvoiceAddressInfo;


// WEBPACK FOOTER //
// ./src/components/globalModals/EditInvoiceAddressInfo.jsx